import { render, staticRenderFns } from "./EmployeeworkhoursPage.vue?vue&type=template&id=58666fb3"
import script from "./EmployeeworkhoursPage.vue?vue&type=script&lang=js"
export * from "./EmployeeworkhoursPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports